import {
    ChangeDetectionStrategy,
    Component,
    Input,
    OnDestroy,
    OnInit,
    ViewChild,
    ViewEncapsulation,
} from '@angular/core';
import { MatMenuTrigger } from '@angular/material/menu';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'fi-text-item-media-panel-item-base',
    template: ``,
    styleUrls: ['./fi-text-item-media-panel-item-base.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-text-item-media-panel-item-base' },
    standalone: false,
})
export class FiTextItemMediaPanelItemBaseComponent implements OnInit, OnDestroy {
    @ViewChild(MatMenuTrigger) trigger: MatMenuTrigger;
    @Input() closeMenu$ = new Observable();

    isMenuOpened: boolean;

    constructor() {}

    ngOnInit(): void {
        this.closeMenu$.pipe(takeUntil(this.ngOnDestroy$)).subscribe(() => {
            if (this.isMenuOpened) {
                this.trigger.closeMenu();
            }
        });
    }

    ngOnDestroy$ = new Subject<void>();
    ngOnDestroy() {
        this.ngOnDestroy$.next();
        this.ngOnDestroy$.complete();
    }

    toggleMenuBrandedClass(isMenuOpened: boolean): void {
        this.isMenuOpened = isMenuOpened;
    }

    toggleMenu() {
        this.trigger.closeMenu();
        setTimeout(() => {
            this.trigger.openMenu();
        }, 100);
    }
}
